export default __webpack_public_path__ + "static/media/Revivfying Atlantean Catalyst.4729ee9c.jpg";